export const shiftlistdata = [
  {
    id: 1,
    shiftname: "Fixed",
    time: "09:00 AM - 6:00 PM",
    weekoff: "Sunday, Monday",
    createdon: "04 Aug 2023",
    status: "Active",
  },
  {
    id: 2,
    shiftname: "Rotating",
    time: "06:00 AM - 3:00 PM",
    weekoff: "Saturday, Sunday",
    createdon: "21 July 2023",
    status: "Inactive",
  },
  {
    id: 3,
    shiftname: "Split",
    time: "03:00 AM - 9:00 PM",
    weekoff: "Tuesday, Saturday",
    createdon: "31 Jan 2022",
    status: "Active",
  },
  {
    id: 4,
    shiftname: "On-Call",
    time: "09:00 AM - 6:00 PM",
    weekoff: "Monday",
    createdon: "15 May 2023",
    status: "Active",
  },
  {
    id: 5,
    shiftname: "Weekend",
    time: "06:00 AM - 3:00 PM",
    weekoff: "Friday",
    createdon: "04 Aug 2023",
    status: "Active",
  },
];
